// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { media } from '@toggl/style'

export const TwoFieldWrapper = styled<{ children: React.Node }>('div')`
  display: flex;
  flex-direction: column;
  ${media.mq[1]} {
    flex-direction: row;
    > div:first-of-type,
    > button:first-of-type {
      margin-right: 20px;
    }
    > button {
      margin-bottom: 30px;
    }
  }
`
